/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Email_Task_Assigned_Plain_ActionInputs */

const en_email_task_assigned_plain_action = /** @type {(inputs: Email_Task_Assigned_Plain_ActionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open the task: ${i?.url}`)
};

const pt_br2_email_task_assigned_plain_action = /** @type {(inputs: Email_Task_Assigned_Plain_ActionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abra a atividade: ${i?.url}`)
};

/**
* | output |
* | --- |
* | "Open the task: {url}" |
*
* @param {Email_Task_Assigned_Plain_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const email_task_assigned_plain_action = /** @type {((inputs: Email_Task_Assigned_Plain_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Task_Assigned_Plain_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_email_task_assigned_plain_action(inputs)
	return pt_br2_email_task_assigned_plain_action(inputs)
});